export default (props = {}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"{...props}><path fill="currentColor" d="M5 14V9h1v4h12V9h1v5z"/></svg>